import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { StorageService } from '../../../../services/storage.service';

@Component({
    selector: 'app-multiple-device-detected-popup',
    templateUrl: './multiple-device-detected-popup.component.html',
})
export class MultipleDeviceDetectedPopupComponent implements OnInit, OnDestroy {
    public counter: number = 5;

    private intervalId!: NodeJS.Timeout;

    constructor(
        private dialogRef: MatDialogRef<MultipleDeviceDetectedPopupComponent>,
        private router: Router,
        private storageService: StorageService,
    ) {}

    ngOnInit(): void {
        this.initRedirectionCounter();
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    protected redirect(): void {
        this.dialogRef.close();
        this.router.navigate(['login']);
        this.storageService.clear();
    }

    private initRedirectionCounter(): void {
        this.intervalId = setInterval(() => {
            if (this.counter > 0) {
                this.counter--;
            } else {
                clearInterval(this.intervalId);

                this.redirect();
            }
        }, 1000);
    }
}
